import { render } from "./App.vue?vue&type=template&id=ad1f5b6c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ad1f5b6c&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad1f5b6c"]])

export default __exports__